
import * as React from "react";
import $ from "jquery";
import { Api } from "../../lib/Api";


interface ICloseTodayProps {
    changed                             : Function
    restaurantId                        : number
    openCloseRestaurantTodayModal       : boolean
    RestaurantIsOpen                    : boolean
}

interface ICloseTodayState  {
    error                               : string
    success                             : string
    loading                             : boolean
}


export default class CreateOffer extends React.Component<ICloseTodayProps, ICloseTodayState> {
    constructor(props:ICloseTodayProps){
        super(props);
        this.state = {
            success                         : null,
            error                           : null,
            loading                         : false
        };
    }

    private reopenRestaurantBtnClickHandler(evt): void {
        evt.preventDefault();
        $('#close_restaurant_modal').modal('toggle');
        if ( document.querySelector('.modal-backdrop') !== null ) {
            $('.modal-backdrop').remove();
        }
        this.setState({
            loading: true,
        }, ()=>{
            Api.call('/restaurant/reOpenToday', {
                restaurantId: this.props.restaurantId
            }, (result)=>{
                this.setState({
                    error                        : result.error,
                    success                      : result.success,
                    loading                      : false
                }, ()=>{
                    this.props.changed();
                });
            });
        });
    }

    private addCloseRestaurantForTodayBtnClickHandler(evt): void {
        evt.preventDefault();

        this.setState({
            loading: true,
        }, ()=>{
            Api.call('/restaurant/closeForToday', {
                restaurantId: this.props.restaurantId
            }, (result)=>{
                this.setState({
                    error                        : result.error,
                    success                      : result.success,
                    loading                      : false
                }, ()=>{
                    $('#view_modal').modal('toggle');
                    if ( document.querySelector('.modal-backdrop') !== null ) {
                        $('.modal-backdrop').remove();
                    }
                    this.props.changed();
                   // this.init();
                });
            });

        });
    }


    render(){
        return (
            <>
                { this.props.openCloseRestaurantTodayModal &&
                <div role="dialog" className="modal fade" id="close_restaurant_modal">
                    <div className="modal-dialog modal-md" role="document">
                        <div className="modal-content">
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col"/>
                                    <div className="col 8">
                                        <div className="text-center">
                                            <img src="img/restaurant/icons/figura_icon.svg" alt="" width={200} />
                                        </div>
                                        {
                                            this.props.RestaurantIsOpen ?
                                                <button className="red_btn" id="add_close_for_today_btn" onClick={(e) => { this.addCloseRestaurantForTodayBtnClickHandler(e); } }>
                                                    Close today
                                                </button> :
                                                <button className="green_btns" id="reopen_restaurant_bottom_list_btn" onClick={(e) => { this.reopenRestaurantBtnClickHandler(e); } }>
                                                    Reopen
                                                </button>
                                        }
                                    </div>
                                    <div className="col"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                }
            </>

        );
    }
}
